module.exports = __webpack_public_path__ + "static/img/calender.3a3a398.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/calender.svg
// module id = 353
// module chunks = 37